import { postAddAnnualIncome } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const add_incomeThunk = createAsyncThunk(
  "add_incomeThunk",
  async ({ body, token }) => {
    try {
      const response = postAddAnnualIncome(body, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
